module.exports = __webpack_public_path__ + "static/media/reciprocal_pronoun_img.37441913.JPG";